// models
import type {
  ReqApproval,
  ReqApprovalList,
  ReqChangeId,
  ReqLogin,
  ReqReject,
  ReqSignUp
} from '../models/auth.model';

/**
 * Auth 관련 Query Keys
 *
 * @description
 * 인증/인가 관련 query-key들을 관리합니다.
 */
export const authKeys = {
  /** ALL */
  AUTH_ALL: ['auth'],

  /** 회원가입 */
  SIGN_UP: (params?: ReqSignUp) => ['auth', 'signUp', JSON.stringify(params)],

  /** 회원가입: 사용자 정보 + 파일 */
  SIGN_UP_WITH_FILE: (params?: { user: ReqSignUp; file: File }) => [
    'auth',
    'signUpWithFile',
    JSON.stringify(params)
  ],

  /** Password 로그인 */
  LOGIN: (params?: ReqLogin) => ['auth', 'login', JSON.stringify(params)],

  /** userId 통한 비밀번호 변경 */
  CHANGE_PASSWORD: (params?: { userId: string; newPassword: string }) => [
    'auth',
    'changePassword',
    JSON.stringify(params)
  ],

  /** 아이디 변경 */
  CHANGE_ID: (params?: ReqChangeId) => ['auth', 'changeId', JSON.stringify(params)],

  /** 가입 승인 관리자 페이지 조회 */
  APPROVAL: (params?: ReqApprovalList) => ['auth', 'approval', JSON.stringify(params)],

  /** 가입 승인 */
  APPROVE_USERS: (params?: ReqApproval) => ['auth', 'approveUsers', JSON.stringify(params)],

  /** 가입 거절 */
  REJECT_USERS: (params?: ReqReject) => ['auth', 'rejectUsers', JSON.stringify(params)]
};
